import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AscendingIcon from "../../../assets/icons/ascending-icon.svg";
import DescendingIcon from "../../../assets/icons/descending-icon.svg";

import { ListItemIcon, ListItemText } from "@mui/material";

interface PropsType {
  label: string;
  icon: React.ReactNode;
  menuList?: Array<any>;
  onMenuCB: (type: string) => void;
}

export default function CustomMenu(props: PropsType) {
  const { label, icon, onMenuCB } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onMenuClick = (type: string) => {
    onMenuCB(type);
    handleClose();
  };

  return (
    <div>
      <Button
        id="basic-button"
        className="menu-action"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        style={{ color: "#000", textTransform: "none", fontFamily: "inherit" }}
      >
        {label} {icon}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => onMenuClick("ASC")}>
          <ListItemIcon>
            <img
              src={AscendingIcon}
              tabIndex={0}
              alt="ascending icon"
              width="20px"
              height="20px"
            />
          </ListItemIcon>
          <ListItemText>Sort Ascending</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => onMenuClick("DESC")}>
          <ListItemIcon>
            <img
              src={DescendingIcon}
              tabIndex={0}
              alt="ascending icon"
              width="20px"
              height="20px"
            />
          </ListItemIcon>
          <ListItemText>Sort Descending</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}
